import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { WaiterAuthProvider, useWaiterAuth } from './context/WaiterAuthContext';
import { TableProvider } from './context/TableContext';
import { TerminalProvider } from './context/TerminalContext';
import { BillingProvider } from '../admin/context/BillingContext';
import WaiterLogin from './pages/WaiterLogin';
import WaiterDashboard from './pages/WaiterDashboard';
import OrderLine from './pages/OrderLine';
import OrderLinePetpooja from './pages/OrderLinePetpooja';
import TakeOrder from './pages/TakeOrder';
import BillPrinting from './pages/BillPrinting';
import TableManagement from './pages/TableManagement';
import DayReport from './pages/DayReport';
import TerminalManagement from './pages/TerminalManagement';
import MasterPOSDashboard from './pages/MasterPOSDashboard';
import './WaiterApp.css';

const ProtectedRoute = ({ children }) => {
  const { currentWaiter, loading, outletError, logout } = useWaiterAuth();

  if (loading) {
    return (
      <div className="waiter-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Show outlet error if present
  if (currentWaiter && outletError) {
    return (
      <div className="waiter-error-container">
        <div className="error-card">
          <div className="error-icon">⚠️</div>
          <h2>Outlet Not Found</h2>
          <p>{outletError}</p>
          <div className="error-details">
            <p><strong>Waiter:</strong> {currentWaiter.name}</p>
            <p><strong>Email:</strong> {currentWaiter.email}</p>
            <p><strong>Assigned Outlet ID:</strong> {currentWaiter.primaryOutlet}</p>
          </div>
          <div className="error-instructions">
            <h3>What to do:</h3>
            <ol>
              <li>Contact your administrator or manager</li>
              <li>Ask them to check the "Outlets" section in admin panel</li>
              <li>Verify that your assigned outlet exists and is active</li>
              <li>Ask admin to reassign you to a valid outlet in the "Users" section</li>
            </ol>
          </div>
          <button
            className="btn-logout"
            onClick={() => {
              logout();
              window.location.href = '/waiter/login';
            }}
          >
            Logout & Try Again
          </button>
        </div>
      </div>
    );
  }

  return currentWaiter ? children : <Navigate to="/waiter/login" replace />;
};

const WaiterRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<WaiterLogin />} />
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <WaiterDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="order-line"
        element={
          <ProtectedRoute>
            <OrderLinePetpooja />
          </ProtectedRoute>
        }
      />
      <Route
        path="take-order/:tableId"
        element={
          <ProtectedRoute>
            <TakeOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="bill/:orderId"
        element={
          <ProtectedRoute>
            <BillPrinting />
          </ProtectedRoute>
        }
      />
      <Route
        path="tables"
        element={
          <ProtectedRoute>
            <TableManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="report"
        element={
          <ProtectedRoute>
            <DayReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="terminals"
        element={
          <ProtectedRoute>
            <TerminalManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="master-pos"
        element={
          <ProtectedRoute>
            <MasterPOSDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/waiter/order-line" replace />} />
    </Routes>
  );
};

const WaiterApp = () => {
  return (
    <WaiterAuthProvider>
      <BillingProvider>
        <TerminalProvider>
          <TableProvider>
            <div className="waiter-app">
              <WaiterRoutes />
            </div>
          </TableProvider>
        </TerminalProvider>
      </BillingProvider>
    </WaiterAuthProvider>
  );
};

export default WaiterApp;
